// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__34w_i","footer":"ModalFilter_footer__lmCY8"};